import React from 'react';

import AccountEmailForm from './AccountEmailForm';
import AccountLoginSubHeader from './AccountLoginSubHeader';
import AccountPasswordForm from './AccountPasswordForm';

import './AccountLoginAndRegistrationFormStyles.less';

export interface IAccountLoginFormProps {
  disableEmail?: boolean;
  email?: string;
  headerText?: string;
  subHeaderText?: string;
  loading?: boolean;
  loginError?: string | boolean;
  onSubmit: (email: string, password: string, rememberMe: boolean) => void;
}

export interface IAccountLoginFormState {
  email: string;
  hasSubmittedEmail: boolean;
  password: string;
  rememberMe: boolean;
}

export default class AccountLoginForm extends React.Component<
  IAccountLoginFormProps,
  IAccountLoginFormState
> {
  public static defaultProps: Partial<IAccountLoginFormProps> = {
    email: '',
    headerText: 'Welcome back',
  };

  public state: IAccountLoginFormState = {
    email: this.props.email,
    hasSubmittedEmail: !!this.props.disableEmail && !!this.props.email,
    password: '',
    rememberMe: true,
  };

  public componentWillReceiveProps(nextProps: IAccountLoginFormProps) {
    const { email } = this.props;
    if (email !== nextProps.email) {
      this.setState({ email: nextProps.email || '' });
    }
  }

  public handleChangeRememberMe = (rememberMe: boolean) => {
    this.setState({ rememberMe });
  };

  public handleEmailSubmit = (email: string) => {
    this.setState({ email, hasSubmittedEmail: true });
  };

  public handlePasswordSubmit = (password: string) => {
    const { onSubmit } = this.props;
    const { email, rememberMe } = this.state;

    onSubmit(email, password, rememberMe);
  };

  // Toggles to the email request view and allows user to change theemail being used to log in
  public resetValidEmail = e => {
    e.preventDefault();
    this.setState({ hasSubmittedEmail: false, password: '' });
  };

  public render() {
    const { headerText, subHeaderText, loading, loginError } = this.props;
    const { email, rememberMe, hasSubmittedEmail } = this.state;

    return (
      <div className="account-login-form">
        <h1 className="login-header text-center">{headerText}</h1>
        <AccountLoginSubHeader
          email={email}
          hasSubmittedEmail={hasSubmittedEmail}
          subHeaderText={subHeaderText}
          onValidEmailReset={this.resetValidEmail}
        />
        {hasSubmittedEmail ? (
          <AccountPasswordForm
            email={email}
            rememberMe={rememberMe}
            loading={loading}
            loginError={loginError}
            onSubmit={this.handlePasswordSubmit}
            onChangeRememberMe={this.handleChangeRememberMe}
          />
        ) : (
          <AccountEmailForm
            email={email}
            rememberMe={rememberMe}
            loading={loading}
            onSubmit={this.handleEmailSubmit}
            onChangeRememberMe={this.handleChangeRememberMe}
          />
        )}
      </div>
    );
  }
}
